import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/project-assets/Left-side-menu/Cafés.svg";
import Fashion from "@/assets/project-assets/Left-side-menu/Fashion.svg";
import ATM from "@/assets/project-assets/Left-side-menu/ATM.svg";
import CustomerServiceDesk from "@/assets/project-assets/Left-side-menu/Info.svg";
import BeautyWellness from "@/assets/project-assets/Left-side-menu/Beauty-Wellness.svg";
import BooksStationery from "@/assets/project-assets/Left-side-menu/Books-Stationery.svg";
import Bus from "@/assets/project-assets/Left-side-menu/Bus.svg";
import Desserts from "@/assets/project-assets/Left-side-menu/Confectionary.svg";
import Entrance from "@/assets/project-assets/Left-side-menu/Entrance.svg";
import FastFood from "@/assets/project-assets/Left-side-menu/Fast-food.svg";
import GiftCard from "@/assets/project-assets/Left-side-menu/Gift-cards.svg";
import HandsFreeService from "@/assets/project-assets/Left-side-menu/Hands-free.svg";
import HomeTech from "@/assets/project-assets/Left-side-menu/Home-Tech.svg";
import Hypermarket from "@/assets/project-assets/Left-side-menu/Hypermarkets.svg";
import JewelleryWatches from "@/assets/project-assets/Left-side-menu/Jewellery-Watches.svg";
import Kids from "@/assets/project-assets/Left-side-menu/Kids-Maternity.svg";
import LostFound from "@/assets/project-assets/Left-side-menu/Box.svg";
import LuggageBagDrop from "@/assets/project-assets/Left-side-menu/cart-flatbed-suitcase-sharp-light.svg";
import Luxury from "@/assets/luxury-mo.svg";
import LuxuryWhite from "@/assets/luxury-mo-white.svg";
import MallManager from "@/assets/project-assets/Left-side-menu/Manager.svg";
import OpticsEyewear from "@/assets/project-assets/Left-side-menu/Optics-Eyewear.svg";
import Parking from "@/assets/project-assets/Left-side-menu/Parking.svg";
import PrayerRoomMale from "@/assets/project-assets/Left-side-menu/Prayer-room-male.svg";
import PrayerRoomFemale from "@/assets/project-assets/Left-side-menu/Prayer-room-female.svg";
import RedCrescent from "@/assets/project-assets/Left-side-menu/Charity.svg";
import Restaurant from "@/assets/project-assets/Left-side-menu/Restaurant.svg";
import RestroomFemale from "@/assets/project-assets/Left-side-menu/Female.svg";
import RestroomMale from "@/assets/project-assets/Left-side-menu/Men.svg";
import Services from "@/assets/project-assets/Left-side-menu/Services.svg";
import SpecialtyShop from "@/assets/project-assets/Left-side-menu/Specialty-shop.svg";
import SportsLeisure from "@/assets/project-assets/Left-side-menu/Sports-Leisure.svg";
import Taxi from "@/assets/project-assets/Left-side-menu/Taxi.svg";
import ToysGames from "@/assets/project-assets/Left-side-menu/Toys-Games.svg";
import UberCareem from "@/assets/project-assets/Left-side-menu/Uber.svg";
import ValetParking from "@/assets/project-assets/Left-side-menu/Valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/project-assets/Left-side-menu/Coin.svg";
import Stroller from "@/assets/project-assets/Left-side-menu/Stroller.svg";
import Wheelchair from "@/assets/project-assets/Left-side-menu/Wheelchair.svg";
import BabyChangingFemale from "@/assets/project-assets/Left-side-menu/Female-Baby-Changing.svg";
import BabyChangingMale from "@/assets/project-assets/Left-side-menu/Male-baby-changing.svg";
import ParkingAssist from "@/assets/project-assets/Left-side-menu/Park-assist.svg";
import FirstAid from "@/assets/project-assets/Left-side-menu/First-aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import DubaiMetro from "@/assets/project-assets/Left-side-menu/train-subway-tunnel-light.svg";
import GiftWrapping from "@/assets/project-assets/Left-side-menu/gift-light.svg";
import Hotel from "@/assets/stay.svg";
import HotelWhite from "@/assets/project-assets/Left-side-menu/hotel-solid-white.svg";
import HotelLight from "@/assets/stay-light.svg";
import ParkingPay from "@/assets/project-assets/Left-side-menu/coins-light.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment-light.svg";
import iFly from "@/assets/ifly-light.svg";
import LittleExplorers from "@/assets/little-explorers-light.svg";
import MagicPlanet from "@/assets/magic-planet-light.svg";
import Snow from "@/assets/snow-light.svg";
import VoxCinema from "@/assets/vox-cinema-light.svg";
import LuxuryLight from "@/assets/luxury-light.svg";
import LuxuryFashion from "@/assets/luxury-fashion.svg";
import LuxuryJewellery from "@/assets/luxury-jewellery.svg";
import LuxuryBeauty from "@/assets/luxury-beauty.svg";
import LuxuryHomeTech from "@/assets/luxury-home-tech.svg";
import LuxuryOptics from "@/assets/luxury-optics.svg";
import LuxurySpecialty from "@/assets/luxury-specialty.svg";
import LuxuryRestaurants from "@/assets/luxury-restaurants.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "fashion-dome",
    id: "luxury",
    color: "45,28%,47%",
    iconImage: Luxury,
    iconImageAlt: LuxuryWhite,
    items: [
      {
        title: "luxury-category",
        iconImage: LuxuryLight,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:a88caaf5-4007-46ac-85ff-6e009481a1a7",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-fashion",
        iconImage: LuxuryFashion,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:b95ad28c-d965-4c86-a7e1-4c74c2bff4cb",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-jewellery",
        iconImage: LuxuryJewellery,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:8d0576a9-8764-4929-8063-0b45414db77a",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-beauty",
        iconImage: LuxuryBeauty,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:64741e33-8140-479c-a11a-1b85d36a0217",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-tech",
        iconImage: LuxuryHomeTech,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:80dd246e-e52f-4c81-b0bd-30e99bf70ec3",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-optics",
        iconImage: LuxuryOptics,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:3608ee60-0560-4cf0-a724-dc44bdb09ae4",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-specialty",
        iconImage: LuxurySpecialty,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:f2607ecf-10ed-4f3b-9bf2-0a6ac25743b3",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury-restaurants",
        iconImage: LuxuryRestaurants,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:de162f1d-a240-4213-b906-0f903a7eee6a",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "shop",
    id: "shop",
    color: "343,68%,28%",
    icon: FaBagShopping,
    items: [
      {
        title: "fashion",
        iconImage: Fashion,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:e51457cf-f559-429f-93dc-a80d642e2e10",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "beauty-wellness",
        iconImage: BeautyWellness,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:7e55d0d7-3a69-447f-9b79-950077a3689c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "kids-maternity",
        iconImage: Kids,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:100571bc-02cc-4b95-b054-b25254fbf85c",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "toys-games",
        iconImage: ToysGames,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:fe3223d0-626c-4a49-8d56-821e410e890c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "home-tech",
        iconImage: HomeTech,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:da669367-9053-4436-b5a3-94695461a5f0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sport-leisure",
        iconImage: SportsLeisure,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:5f058037-4f64-4de0-acf0-f67631414e7b",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:96c7d374-8a5f-4b36-9bc9-68d3b01f6863",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery",
        iconImage: BooksStationery,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:7af1f7fb-1a03-4d89-bb98-14b46b6ad206",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-eyewear",
        iconImage: OpticsEyewear,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:a51800da-a0fd-4c1a-9186-0c9099fb2a52",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality",
        iconImage: SpecialtyShop,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:7d70c37b-51a1-4ddb-98d9-143e6b2478d1",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:92efc281-d4fa-4e91-aef2-edc954e6a68a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services",
        iconImage: Services,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:181dac82-55aa-40c8-83e2-46527b1cf4fb",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "182, 81%, 24%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:ddf5eb88-2591-47f8-bdad-64212466a8c8",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "desserts",
        iconImage: Desserts,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:242d0d06-e6e9-42de-ad55-30cf46049f00",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:5b17ea6a-9dbc-47a3-9066-3f65f5355577",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: Restaurant,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:eebedb67-308b-47f6-b987-336d97bd9e19",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "leisure",
    id: "leisure",
    color: "207,19%,53%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "unwind-stay",
    id: "unwind-stay",
    color: "311,78%,20%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    items: [
      {
        title: "kempinski",
        iconImage: HotelLight,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:12f77321-5d4a-4ef3-8ac7-3d7366ce1453",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sheraton",
        iconImage: HotelLight,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:3df051fd-9d38-4dc3-b5d9-d04e96ddb0c1",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "218,48%,22%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:1b40e189-bdd8-4d9a-8ad7-a0b9451cf615",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:b0d50607-4ec8-4920-8a68-60e7fab11716",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:c1266923-a921-4d0a-b785-334a7a8ef127",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:03176f78-4970-4ac6-8071-c543ea0f98b7",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:a178d4a9-c4db-4e20-8785-ea2542de4970",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:9835a22c-0013-4768-a7ea-b7f9f201e5b3",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:c1266923-a921-4d0a-b785-334a7a8ef127",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:03176f78-4970-4ac6-8071-c543ea0f98b7",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:c1266923-a921-4d0a-b785-334a7a8ef127",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:03176f78-4970-4ac6-8071-c543ea0f98b7",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "dubai-metro",
        iconImage: DubaiMetro,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:c9f87cde-b125-49d6-bb43-1e673cbf0370",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "taxi-stand",
        iconImage: Taxi,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:9547973a-1446-4f59-887b-ebd70ad46320",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:83c6e671-56fb-45f9-99d1-a0fba18411f3",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-station",
        iconImage: Bus,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:725b5448-5a0d-411c-b833-6f5d27e52339",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:f919f2d0-b368-4e0e-a281-473fe2a29aa6",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-pay-station",
        iconImage: ParkingPay,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:19feed3d-97d4-4040-9981-a1929fc49158",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:69a4b203-8f14-454a-a0b5-998853d5c433",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:45dddd93-d9d8-4fc1-bd90-8eed1cf0b7b2",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:7f7bd7de-73d6-4bb3-9927-2fe9cf78cc25",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:10cdfd60-fafb-41ef-9eb7-c9679c2805ae",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:87d8f109-cb5f-409d-974b-e87d14f70203",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "luggage-bag-drop",
        iconImage: LuggageBagDrop,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:6a363097-b4bf-422c-90ea-959f400c7ad0",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "hands-free-service",
        iconImage: HandsFreeService,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:43b76ea3-20c3-444c-8e52-e69533f44063",
        ],
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:80ae4b1b-3d3b-415a-b9e4-6b3148f08cd4",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "gift-wrapping",
        iconImage: GiftWrapping,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:9835a22c-0013-4768-a7ea-b7f9f201e5b3",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "first-aid",
        iconImage: FirstAid,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:09ba9451-5f0d-4836-a092-abb306c2be5a",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:09b415a9-4efc-4269-a151-f39412890d7d",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-strollers",
        iconImage: Stroller,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:e0e73dd3-1a56-4d09-a275-bc1b91d40920",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:9835a22c-0013-4768-a7ea-b7f9f201e5b3",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:1cfa3bbc-22a6-4232-8d25-e9a9cf3cd271",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:17330822-6686-4231-95b2-fd4222b1d6d3",
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:9353fa34-8916-4230-b879-a7ae7d035e6a",
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:238efa6b-ce6d-4afa-b5fa-9e3c9a0a81ce",
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:952212ef-b31b-4ce1-ba29-0ffc3b3717cc",
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:c9341c9b-fa27-4e35-8e10-12fd11373ac5",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:dbf46aa3-88c6-49e9-850c-e986b8946836",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: false,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:6c23318a-3d75-42c9-9a23-a50eda01d2b0",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:3af3166e-69ee-42dd-915e-c5744677ebea",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At Mall of the Emirates</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in Mall of the Emirates and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في مول الإمارات<h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في مول الإمارات وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "leisure",
  );
  filterCategories[entertainmentIndex].items = items;
};
